export const ReportManagementMenuDef = [
    {
        "name": "menu.report_template",
        "resource": "report_template",
        "icon": "fa fa-tag",
        "url": "report_template",
        "auto_crud": true,
        "breadcrumb": "Report Template",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.requested_downloads",
        "resource": "requested_downloads",
        "icon": "fa fa-tag",
        "url": "requested_downloads",
        "auto_crud": true,
        "breadcrumb": "Report Template",
        "check_permission": false,
        "showMenu": true
      },
      {
        "name": "menu.report_data_collector",
        "resource": "report_data_collector",
        "icon": "fa fa-tag",
        "url": "report_data_collector",
        "auto_crud": true,
        "breadcrumb": "Report Data Collector",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.report_identification",
        "resource": "report_identification",
        "icon": "fa fa-tag",
        "url": "report_identification",
        "auto_crud": true,
        "breadcrumb": "Report Identification",
        "check_permission": true,
        "showMenu": true
      },{
        "name": "menu.report_template",
        "resource": "facility_report_template",
        "icon": "fa fa-tag",
        "url": "facility_report_template",
        "auto_crud": true,
        "breadcrumb": "Facility Report Template",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.report_identification",
        "resource": "facility_report_identification",
        "icon": "fa fa-tag",
        "url": "facility_report_identification",
        "auto_crud": true,
        "breadcrumb": "Facility Report Identification",
        "check_permission": true,
        "showMenu": true
      },
      {
        "name": "menu.facility_report_data_collector",
        "resource": "facility_report_data_collector",
        "icon": "fa fa-tag",
        "url": "facility_report_data_collector",
        "auto_crud": true,
        "breadcrumb": "Facility Report Data Collector",
        "check_permission": true,
        "showMenu": true
      },
      
]